// extracted by mini-css-extract-plugin
module.exports = {"bb-heading":"bb-heading__luP5d"};